import { api } from "@/lib/api"
import { sumWorkspaceSeries } from "./workspace-series-total"
import { WorkspaceStackedBarChart } from "./workspace-stacked-bar-chart"

const usd = (value: number) =>
	`$${value.toLocaleString("en-US", {
		maximumFractionDigits: value < 10 ? 2 : 0,
	})}`

export function AiCreditUsageChart() {
	const query = api.analytics.aiCreditUsageChart.useQuery({})
	const total = sumWorkspaceSeries(query.data)

	return (
		<WorkspaceStackedBarChart
			title="AI credit usage"
			description="Metered token spend at our rate, the figure that eats a workspace's credits and its cap. Support agent chat bills per resolution and thread titles are free, so neither shows up here. The running week is left out."
			data={query.data}
			isLoading={query.isLoading}
			formatValue={usd}
			height="h-[220px]"
			legend={
				total === null ? undefined : (
					<div className="text-right">
						<p className="text-2xl font-semibold tabular-nums text-primary">
							{usd(total)}
						</p>
						<p className="text-xs text-tertiary">charged in the last year</p>
					</div>
				)
			}
		/>
	)
}
